export default "query getConfig {\n    experiments {\n      name\n      value\n    }\n    premiumFeatures {\n      name\n    }\n}\n";